<template lang="html">
    <el-card>
        <table-template :queryParams="queryParams" actionUrl="/plusClue/findPlusClueList.action" ref="table-template">
            <template slot="search">
              <el-row>
                <el-form :inline="true"  class="demo-form-inline">
                  <el-form-item  v-belong-to-admin >
                    <channel-select   @change="channelIdsChange" clearable filterable placeholder="渠道来源" ref="channelSelect"
                    ></channel-select>
                  </el-form-item>
                  <el-form-item v-belong-to-admin >
                    <el-select    @change="$refs['table-template'].search()" @clear="onClear" clearable filterable
                               placeholder="类型"
                              v-model="queryParams.type">
                      <el-option label="新车" value="新车"></el-option>
                      <el-option label="二手车" value="二手车"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-date-picker
                        @change="onDateTimeRangeChange"
                        end-placeholder="创建结束日期"
                        range-separator="至"
                        start-placeholder="创建开始日期"
                        type="datetimerange"
                        v-model="queryParams.createTimes">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-input placeholder="询价商品/商家" v-model='queryParams.keyword'></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="$refs['table-template'].search()" type="primary">搜索</el-button>
                    <el-button @click="exportExcel()" type="warning">导出</el-button>
                  </el-form-item>

                </el-form>
              </el-row>
            </template>

            <template slot="item">
                <el-table-column label="询价人" width="250">
                    <template scope="scope">
                        {{scope.row.personName}} - {{scope.row.phone}}
                    </template>
                </el-table-column>
                <el-table-column label="询价商品" width="250">
                    <template scope="scope">
                        {{scope.row.goodsName}}
                    </template>
                </el-table-column>
                <el-table-column label="价格" width="250">
                    <template scope="scope">
                        {{scope.row.currentPrice}}
                    </template>
                </el-table-column>

                <el-table-column label="类型">
                    <template scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.type }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="询价商家" width="250">
                    <template scope="scope">
                        {{scope.row.businessName}}
                    </template>
                </el-table-column>
                <el-table-column v-if="isAdmin" label="渠道来源" v-belong-to-admin width="250">
                    <template scope="scope">
                        {{scope.row.channelName}}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="250">
                    <template scope="scope">
                        {{scope.row.createTime | dateTimeFormat }}
                    </template>
                </el-table-column>
            </template>
        </table-template>
    </el-card>
</template>

<script>
import BasicPager from '../../mixins/BasicPager'
import TableTemplate from '@/components/TableTemplate'
import Config from '@/framework/configs/Config'
import channelSelect from '@/components/channelSelect'

export default {
  name: 'plus-clue',
  extends: BasicPager,
  components: {
    TableTemplate,
    channelSelect
  },
  data: function () {
    return {
      isAdmin: false,
      queryParams: {
        createTimes: [],
        businessId: '',
        channelId: '',
        type: null,
        keyword: null
      }

    }
  },
  props: {
    carShowId: {
      type: Number,
      default: null
    }
  },
  watch: {
    carShowId: function (newValue) {
      if (this.carShowId) {
        this.queryParams.carShowId = newValue
      }

      this.$refs['table-template'].search()
    }
  },
  created: function () {
    this.isAdmin = userInfo.loginPath != 'channel'
    if (this.carShowId) {
      this.queryParams.carShowId = this.carShowId
    }
  },
  methods: {
    channelIdsChange: function (channelId) {
      this.queryParams.channelId = channelId
      this.$refs['table-template'].search()
    },
    onClear: function () {
      this.queryParams.type = null
      this.$refs['table-template'].search()
    },
    onDateTimeRangeChange: function (time) {
      let createTime = this.queryParams.createTimes

      if (createTime && createTime[0]) {
        this.queryParams.startTime = createTime[0].getTime()
        this.queryParams.endTime = createTime[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }

      this.$refs['table-template'].search()
    },
    exportExcel: function () {
      let _this = this
      let channelId = this.queryParams.channelId
      let type = this.queryParams.type
      let keyword = this.queryParams.keyword
      let startTime = this.queryParams.startTime
      let endTime = this.queryParams.endTime
      let carShowId = this.queryParams.carShowId

      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }

      window.location.href = Config.baseUrl + '/plusClue/exportLcwpClueExcel.action?' +
        'token=' + userInfo.token +
        '&loginAccountId=' + id +
        '&loginPath=' + loginPath +
        (carShowId ? '&carShowId=' + carShowId : '') +
        (channelId ? '&channelId=' + channelId : '') +
        (type ? '&type=' + type : '') +
        (keyword ? '&keyword=' + keyword : '') +
        (startTime ? '&startTime=' + startTime : '') +
        (endTime ? '&endTime=' + endTime : '')
    }

  }
}
</script>

<style lang="css" scoped>
</style>
